import '@straal/core/utils/static/initialLoading.ts'
import './style.sass'

import { CLASSES as classes } from '@straal/globals/configs/elementConsts'

import { ERROR_PLACEHOLDERS as errorTexts } from '@straal/globals/configs/loginConsts'

import L from 'lodash'
import { createSession } from '@straal/core/utils/auth.ts'
import {
  showThrobber,
  hideThrobber,
} from '@straal/assets/staticViews/scripts/interface.ts'
import { Store } from '@straal/kompas/staticViews/_assets/scripts/validation'
import { emailValidator } from '@straal/kompas/staticViews/_assets/scripts/validationRules'

let emailField
let passwordField
let rememberCheckbox
let loginBtn
let throbber
let store

window.onafterload = function() {
  emailField = document.getElementById('email')
  passwordField = document.getElementById('password')
  rememberCheckbox = document.getElementById('remember-me')
  loginBtn = document.getElementById('login-btn')
  throbber = document.querySelector(`.${classes.THROBBER_MAIN}`)

  store = new Store({
    submitButton: loginBtn,
    fields: [
      {
        name: 'email',
        element: emailField,
        validator: emailValidator,
      },
      {
        name: 'password',
        element: passwordField,
      },
    ],
  })

  loginBtn.addEventListener('click', submitForm)
}

// VIEW SPECIFIC FUNCTIONS

const submitForm = function(ev) {
  ev.preventDefault()

  store.submitForm(() => {
    const payload = {
      email: store.getInputValue('email'),
      password: store.getInputValue('password'),
      remember_me: rememberCheckbox.checked,
    }

    showThrobber(throbber)
    login(payload)
  })
}

const login = function(payload) {
  createSession(payload).catch(function(xhr) {
    hideThrobber(throbber)

    const invalidFields = ['email', 'password']
    const fieldsIterator = inputName => {
      store.setInputValidity(inputName, {
        valid: false,
        errors: errorTexts.LOGIN_FIELDS_NOT_CORRECT,
      })
    }
    L.forEach(invalidFields, fieldsIterator)

    store.displayFormValidity()
  })
}
